import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteUsersService = async (userId: string): Promise<void> => {
  await cjPontanegraApi.delete(`/users/${userId}`);
};
